import styled from 'styled-components';
import { COLORS } from '../../../../../../constants/radar';

export const TabContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const TabButton = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ active }) => active ? COLORS.PRIMARY : COLORS.SECONDARY};
  transition: all 0.2s ease;
  font-weight: ${({ active }) => active ? '600' : '400'};
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${({ active }) => active ? COLORS.PRIMARY : 'transparent'};
  }

  &:hover {
    color: ${COLORS.PRIMARY};
  }

  &:focus {
    outline: none;
  }
`;
